import React, { useState, useEffect } from "react";
import {useNavigate } from "react-router-dom";
import {
  Truck,
  Warehouse,
  CornerDownLeft,
  SearchCheck,
  ArrowBigDown,
  ShieldAlert,
  User
} from "lucide-react";

import "./Menu.css";


const Menu = () => {
  const navigate = useNavigate();  
  const nomeUsuario = localStorage.getItem("nomeUsuario") || "Usuário Logado";
  const [showTopUserPanel, setShowTopUserPanel] = useState(false);
  useEffect(() => {
  window.scrollTo(0, 0);
}, []);



const handleLogout = () => {
  sessionStorage.removeItem("token"); // remove o token da sessão
  localStorage.removeItem("nomeUsuario"); // limpa o nome do usuário também
  window.location.href = "/"; // volta para o login
};

  const menuItems = [
    { icon: <Truck size={28} color="#00996D" strokeWidth={1.5} />, title: "Saídas", route: "/saida" },
    { icon: <Warehouse size={28} color="#00996D" strokeWidth={1.5} />, title: "Estoque", route: "/estoque" },
    { icon: <CornerDownLeft size={28} color="#00996D" strokeWidth={1.5} />, title: "Devoluções", route: "/devolucao" },
    { icon: <SearchCheck size={28} color="#00996D" strokeWidth={1.5} />, title: "Decidir", route: "/decisao" },

  ];

return (
  <div className="menu-container">
    {/* TOPO VERDE */}
    <div className="menu-dark-header">
      <div className="menu-logo-icon">
  <img src="/B.png" alt="Logo B" />
</div>
      <div
  className="menu-welcome-wrapper"
  style={{
    zIndex: 2,
    textAlign: "right", // 👈 adiciona isso
    width: "100%"        // garante que ocupe a largura
  }}
>
 <div className="menu-user-box" onClick={() => setShowTopUserPanel(true)}>
  <span className="menu-username">Olá, {nomeUsuario}!</span>

  <div className="user-floating-icon">
    <div className="user-avatar-circle">
      <User size={18} strokeWidth={2} color="rgb(54, 181, 29)" />
    </div>
    <div className="user-vertical-line"></div>

  </div>
</div>
        <p className="menu-subtitle">
  Seu dia mais ágil.<br />
  Sua operação mais fluida.
</p>
      </div>

      {/* espaçador invisível para aumentar o verde */}
      <div style={{ flexGrow: 1 }}></div>
    </div>

    {/* PAINEL DE USUÁRIO SOBRE O TOPO */}
    {showTopUserPanel && (
      <div className="top-user-panel">
        <div className="top-user-header">
          <span className="top-user-name">Olá, {nomeUsuario}!</span>
          <button className="close-button" onClick={() => setShowTopUserPanel(false)}>✕</button>
        </div>

        <div className="top-user-actions">
          <button className="logout-button" onClick={handleLogout}>
            <User size={18} style={{ marginRight: '0.4rem' }} />
            Sair
          </button>
        </div>
      </div>
    )}
  

      {/* CONTEÚDO PRINCIPAL */}
      <div className="menu-content">
        <div className="menu-top-section">
          <div className="menu-top-content">
            <div className="menu-section-title" style={{ textAlign: 'left', alignSelf: 'flex-start', width: '100%' }}>
              O que você quer lançar?
            </div>

            <div className="menu-grid">
             {menuItems.map((item, index) => (
  <div
    key={index}
    className="menu-card-flat shadow fade-in-card"
    onClick={() => navigate(item.route, { state: { usuario: nomeUsuario } })}
  >
    {item.icon}
    <span className="menu-title-bold">{item.title}</span>
  </div>
))}

            </div>

            {/* LANÇAMENTOS ESPECIAIS */}
            <div className="lancamentos-especiais" style={{ alignSelf: 'flex-start', width: '100%' }}>
              <h4 style={{ marginLeft: '0.25rem', color: '#004d29', fontWeight: 'bold', fontSize: '1rem', textAlign: 'left' }}>Lançamentos Especiais</h4>
           <div
  className="lancamentos-grid"
  style={{
    justifyContent: 'center',
    transform: 'translateX(-55px)' // ajuste leve à esquerda
  }}
>
               <div className="lancamento-botao" onClick={() => navigate('/entradas', { state: { usuario: nomeUsuario } })}>
                  <div className="icone-wrapper" style={{ boxShadow: '0 4px 10px rgba(0, 0, 0, 0.12)' }}>
                    <ArrowBigDown size={28} color="#DB0B0E" strokeWidth={1.25} />
                  </div>
                  <span style={{ color: '#DB0B0E', fontWeight: 470, fontSize: '0.85rem' }}>Entradas</span>
                </div>
                
                
                
                {/* DESCOMENTE PARA ATIVAR O BOTÃO DE AREA RESTRITA */}
                {/* <div className="lancamento-botao" onClick={() => navigate('/arearestrita', { state: { usuario: nomeUsuario } })}>
                  <div className="icone-wrapper" style={{ boxShadow: '0 4px 10px rgba(0, 0, 0, 0.12)' }}>
                    <ShieldAlert size={24} color="#DB0B0E" strokeWidth={1.25} />
                  </div>
                  <span style={{ color: '#DB0B0E', fontWeight: 470, fontSize: '0.85rem' }}>Área Restrita</span>
                </div> */}

                {/* COMENTE OU APAGUE PARA ATIVAR BOTAO ÁREA RESTRITA */}
                <div
  className="lancamento-botao"
  style={{ opacity: 0.4, pointerEvents: 'none', cursor: 'not-allowed' }}
>
  <div className="icone-wrapper" style={{ boxShadow: '0 4px 10px rgba(0, 0, 0, 0.12)' }}>
    <ShieldAlert size={24} color="#DB0B0E" strokeWidth={1.25} />
  </div>
  <span style={{ color: '#DB0B0E', fontWeight: 470, fontSize: '0.85rem' }}>Área Restrita</span>
</div>





              </div>
            </div>
          </div>


        
        </div>
      </div>
    </div>
  );
};

export default Menu;
